import ButtonGroup from '@mui/material/ButtonGroup';
import CustomButton from './CustomButton';
import SaveIcon from '@mui/icons-material/Save';
import RestorePageIcon from '@mui/icons-material/RestorePage';
import type { tableSettingsProps } from 'src/hooks/table/tableSettings/useTableSettings';
import {
  AdditionalTableEdits,
  commitPendingTableEdits,
  discardTableEdits,
  getTableSubmitRows,
  hasTableChanges,
} from 'src/hooks/table/tableSettings/tableEditActions';

type SaveDiscardButtonsProps = {
  tableSettings: tableSettingsProps;
  submit: (v: any, options?: any) => void;
  additionalEdits?: AdditionalTableEdits | AdditionalTableEdits[];
};

const SaveDiscardButtons = ({
  tableSettings,
  submit,
  additionalEdits,
}: SaveDiscardButtonsProps) => {
  const hasChanges = hasTableChanges(tableSettings, additionalEdits);

  const save = async () => {
    await commitPendingTableEdits(tableSettings, additionalEdits);

    const submitRows = getTableSubmitRows(tableSettings, additionalEdits);
    submit(submitRows);
  };

  const discard = () => {
    discardTableEdits(tableSettings, additionalEdits);
  };

  return (
    <ButtonGroup>
      <CustomButton
        title="Discard"
        color="error"
        disabled={!hasChanges}
        icon={<RestorePageIcon />}
        onClick={discard}
      />
      <CustomButton
        title="Save"
        disabled={!hasChanges}
        icon={<SaveIcon />}
        onClick={save}
      />
    </ButtonGroup>
  );
};

export default SaveDiscardButtons;